import { FC } from 'react';

import { CountryEntity } from 'api/types/entity';
import { LegalClientBodyEntity } from 'api/types/entity/legal/legalClientBody';
import { isGlobalProject } from 'config';
import { useFormErrorFocus } from 'hooks';
import { Stack } from 'libs/ui';
import {
  ReasonAddSection,
  CompanyNameSection,
  CompanyStateRegistrationSection,
  CompanyRegistrationAndResidentialAddressSection,
  LegalClientAddHeadPositionSection,
} from 'modules/client/common/components/sections';
import {
  CountryRiskProvider,
  CountryRiskRole,
} from 'modules/client/common/feature';
import {
  CompanyOrganizationalAndLegalFormSection,
  CompanyTaxResidencySection,
} from 'modules/client/legal/components/sections';

export interface LegalClientAddLegalHeadSectionsProps {
  countriesLoading?: boolean;
  countries: CountryEntity[];
  bodies: LegalClientBodyEntity[];
}

export const LegalClientAddLegalHeadSections: FC<
  LegalClientAddLegalHeadSectionsProps
> = ({ countries, countriesLoading, bodies }) => {
  useFormErrorFocus();

  const isGlobal = isGlobalProject();
  return (
    <CountryRiskProvider role={CountryRiskRole.LegalClientLegalHead}>
      <Stack spacing={24}>
        <ReasonAddSection />

        <CompanyNameSection hideShortName={isGlobal} />

        <LegalClientAddHeadPositionSection bodies={bodies} />

        <CompanyTaxResidencySection
          countries={countries}
          countriesLoading={countriesLoading}
        />

        <CompanyRegistrationAndResidentialAddressSection
          countries={countries}
          countriesLoading={countriesLoading}
        />

        <CompanyStateRegistrationSection hideDocuments={isGlobal} />

        {isGlobal && (
          <CompanyOrganizationalAndLegalFormSection
            enabledOrganizationType={false}
          />
        )}
      </Stack>
    </CountryRiskProvider>
  );
};
